import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: `${BASE}/api`, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pm_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('pm_admin_token');
    }
    return Promise.reject(err);
  }
);

export default api;
